module.exports = __webpack_public_path__ + "bg_mobile.jpg";